// ApnaFix localities & slots (local) + service normalization from the app backend.
export const LOCALITIES = [
  { id: "kandivali", name: "Kandivali", slug: "kandivali", societies: "45+ societies", areas: "Mahavir Nagar, Thakur Village, Charkop" },
  { id: "malad", name: "Malad", slug: "malad", societies: "40+ societies", areas: "Malad West, Mindspace, Marve Road" },
  { id: "borivali", name: "Borivali", slug: "borivali", societies: "50+ societies", areas: "IC Colony, Shimpoli, Gorai Road" },
  { id: "goregaon", name: "Goregaon", slug: "goregaon", societies: "38+ societies", areas: "Aarey, Film City Road, Motilal Nagar" },
];

export const SLOTS = [
  { id: "now", label: "Today in 30 mins" },
  { id: "morning", label: "Morning (9 AM - 12 PM)" },
  { id: "afternoon", label: "Afternoon (1 PM - 4 PM)" },
  { id: "evening", label: "Evening (5 PM - 8 PM)" },
];

export const getLocality = (slug) => LOCALITIES.find((l) => l.slug === slug);

// Map the app backend's ionicon-style names to lucide-react icon names.
const ICON_MAP = {
  flash: "Zap", water: "Droplets", snow: "Snowflake", hammer: "Hammer",
  construct: "HardHat", build: "Wrench", sparkles: "Sparkles", bug: "Bug",
  car: "Car", "car-sport": "Car", cube: "Package", shirt: "Shirt", tv: "Tv",
  "color-fill": "PaintRoller", brush: "Paintbrush", "color-palette": "Palette",
  leaf: "Leaf", flame: "Flame", bus: "Truck", home: "Home", power: "Plug",
  cut: "Scissors", trash: "Trash2", snowflake: "Snowflake", wind: "Wind",
};

export const slugify = (s = "") =>
  s.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Normalize an app-backend category into the shape our UI components expect.
export function normalizeCategory(cat) {
  const sub = Array.isArray(cat.services) && cat.services.length ? cat.services[0] : null;
  return {
    id: cat.id,
    serviceId: sub ? sub.id : cat.id,
    name: cat.name,
    desc: cat.description || "",
    icon: ICON_MAP[cat.icon] || "Wrench",
    slug: slugify(cat.name),
    priceStarts: cat.starting_price != null ? `₹${cat.starting_price}` : "Custom",
    inspectionFee: cat.inspection_fee,
    avgTime: "Same day",
    badge: "Verified",
    image: cat.image_url || "",
  };
}
